(function(){
    'use strict';

    angular
       .module('appback')
       .factory('GenerallabService', GenerallabService);

   GenerallabService.$inject = ['$http'];

   function GenerallabService($http){

       var service = {
           optionsSelect2 : { 
               ajax: {
                   url: "/backend/altcrm/content/select2",
                   dataType: 'json',
                   delay: 250,
                   data: function (params) {
                     return {
                       q: params.term, // search term
                       page: params.page,
                       field: 'nombre',
                       per_page: 20,
                       //nodetype:'microorganismo'
                     };
                   },
                   processResults: function (data, params) {
                     params.page = params.page || 1;
                     return {
                       results: data.items,
                       pagination: {
                         more: (params.page * 1) < data.total_count
                       }
                     };
                   },
                   cache: true
               }
           },
       };

       return service;
        

   }
})();